import React from 'react';

// This component is designed to be used as a custom component in MDX or similar markdown extensions
const BackUp = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 6000,
      behavior: 'smooth'
    });
  };
  const color = "#004000";

  return (
    <button
      onClick={scrollToTop}
      style={{
        backgroundColor: color, 
        color: "#fffef8", 
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'right',
        marginBottom: '-45px',
        transform: `translateY(-${59}px)`
      }}
      className="inline-block px-3 py-1 font-mono text-sm rounded hover:bg-gray-800 transition-colors"
      aria-label="Back to top"
    >
      BACK TO NAVIGATION
    </button>
  );
};

export default BackUp;